import React, { Component } from 'react';
import afterMounted from '../js/agency';
import $ from 'jquery';

class Nav extends Component {

  componentDidMount() {
    const inHome = window.location.pathname === "/";
    inHome && afterMounted($);
    //console.log(window.location)
    
  }

  render() {

      const inHome = window.location.pathname === "/";
      let menu
      if(inHome) {
        menu = <div>
          <button className="navbar-toggler navbar-toggler-right " type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            Menu
            <i className="fa fa-bars" />
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav text-uppercase ml-auto">
              <li className="nav-item">
                <a className="nav-link js-scroll-trigger" href="#services">Servizi</a>
              </li>
              <li className="nav-item">
                <a className="nav-link js-scroll-trigger" href="#portfolio">Esempi</a>
              </li>
              <li className="nav-item">
                <a className="nav-link js-scroll-trigger" href="#contact">Contattami</a>
              </li>
            </ul>
          </div>
        </div>
      }
      else {
        menu = <div></div>
      }

      return (
  
        /* Navigation */
        <div className="container">
          <a className="navbar-brand js-scroll-trigger" href="/#page-top">NAT Studio</a>
         {menu}
          
        </div>
      );
    }
  };

  export default Nav;